<template>
    <v-container fluid class="">
        <div class="profile-view">
            <v-checkbox
                v-model="displayHelp"
                :label="$t('settings.index.checkbox_text')"
                @change="updateUser"
            ></v-checkbox>
        </div>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    components: {

    },

    props: {

    },

    data: function(){
        return {
            displayHelp: true,
        };
    },

    computed: {
        ...mapGetters([
            'currentUser',
        ])
    },

    mounted: function(){
        this.displayHelp = this.currentUser.display_help;
    },

    methods: {
        updateUser() {
            this.$store.dispatch('patchItem', {
                item: {
                    display_help: this.displayHelp,
                    url: this.currentUser.url,
                    uid: this.currentUser.uid,
                },
                model: 'selfUser',
            }).then(() => {
                this.$store.commit('SET_SNACKBAR', {
                    color: 'success',
                    icon: 'done',
                    text: this.$t('settings.index.user_edit_success'),
                });
                this.$store.commit('SET_DISPLAY_SNACKBAR', true);
            }).catch(() => {
                this.$store.commit('SET_SNACKBAR', {
                    color: 'error',
                    icon: 'error',
                    text: this.$t('settings.index.user_edit_error'),
                });
                this.$store.commit('SET_DISPLAY_SNACKBAR', true);
            });
        }
    },
};
</script>

<style lang="scss">
.profile-view {
    .v-input--selection-controls__input {
        margin-bottom: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Settings/index.vue